/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetUserTeamsResponseItems,
    GetUserTeamsResponseItemsFromJSON,
    GetUserTeamsResponseItemsFromJSONTyped,
    GetUserTeamsResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUserTeamsResponse
 */
export interface GetUserTeamsResponse {
    /**
     * 
     * @type {Array<GetUserTeamsResponseItems>}
     * @memberof GetUserTeamsResponse
     */
    items: Array<GetUserTeamsResponseItems>;
}

export function GetUserTeamsResponseFromJSON(json: any): GetUserTeamsResponse {
    return GetUserTeamsResponseFromJSONTyped(json, false);
}

export function GetUserTeamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserTeamsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetUserTeamsResponseItemsFromJSON)),
    };
}

export function GetUserTeamsResponseToJSON(value?: GetUserTeamsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GetUserTeamsResponseItemsToJSON)),
    };
}


